import { ReactNode } from 'react';

import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { SimpleTooltip } from '@/components/ui/simple-tooltip';

interface BalanceAvailableValueProps {
  primary: ReactNode;
  secondary?: ReactNode;
  secondaryTooltip?: ReactNode;
}

export const BalanceAvailableValue = ({
  primary,
  secondary,
  secondaryTooltip,
}: BalanceAvailableValueProps) => {
  const { t } = useTranslation('authenticated.timeOff');

  if (secondary === undefined || secondary === null) {
    return <span className="text-sm font-semibold">{primary}</span>;
  }

  return (
    <span className="flex items-center gap-1 whitespace-nowrap text-sm font-semibold">
      <span className="whitespace-nowrap">{primary}</span>
      <span className="whitespace-nowrap text-muted-foreground">{` / ${secondary}`}</span>
      <SimpleTooltip content={secondaryTooltip}>
        <button
          type="button"
          className="text-muted-foreground transition-colors hover:text-foreground"
          aria-label={t('balances.requestedTooltip.ariaLabel')}
        >
          <Info className="h-3.5 w-3.5" />
        </button>
      </SimpleTooltip>
    </span>
  );
};
